// extracted by mini-css-extract-plugin
module.exports = {"providerDisclaimer":"cc_providerDisclaimer_1014780759"};